<template>
  <div>
    <div class="container">
      <img style="width: 100%" src="../../assets/images/news/icon_01.png"/>
      <div class="tab flex" :style="tabList.length<2?'justify-content: center;':'justify-content: space-around'">
        <div class="tab-item" @click="tabSwitch(item,index)" :class="activeIndex==index?'tab-item-select':''" v-for="(item,index) in tabList" :key="index">{{item.name}}</div>
      </div>
      <div class="detail pc_container" v-if="detail">
        <div class="detail-top">
          <div class="detail-title">{{detail.title || ''}}</div>
          <div class="detail-tips flex">
            <div v-if="detail.created_at">线上发布时间：{{detail.created_at.substr(0,10) ||''}}</div>
            <div v-if="detail.author" style="margin-left: 10px">作者：{{detail.author || ''}}</div>
            <div v-if="detail.department" style="margin-left: 10px">发布部门：{{detail.department || ''}}</div>
          </div>
        </div>
        <div v-if="list && list.length">
          <div class="swiper-top-box flex">
            <div >
              <img v-if="play.type==='image'" class="swiper-top-item-pic" :src="play.url"/>
              <video autoplay controls v-if="play.type==='video'" class="swiper-top-item-pic" :src="play.url"></video>
            </div>
          </div>
          <div class="swiper-box flex">
            <img @click="swiperPrev" class="swiper-switch" src="../../assets/images/news/icon_05.png"/>
            <el-carousel :autoplay="false" :loop="false" ref="swiper" class="swiper" indicator-position="none" arrow="never">
              <el-carousel-item class="swiper-item" v-for="(item,index) in list" :key="index">
                <div class="flex">
                  <div @click="select(i)" v-for="(i,j) in item" class="swiper-pic-box flex" :key="(index+'-'+j)" style="">
                    <div class="swiper-pic flex" v-if="i.type==='image'" :class="play.url===i.url?'swiper-pic-select':''" :style="'background-image: url('+i.url+');'">
                      <div>{{(index+1)*(j+1)}}/{{totalList.length}}</div>
                    </div>
                    <div v-if="i.type==='video'">
                      <video class="swiper-pic flex" :class="play.url===i.url?'swiper-pic-select':''" :src="i.url"></video>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
            <img @click="swiperNext" class="swiper-switch" src="../../assets/images/news/icon_06.png"/>
          </div>
        </div>
        <div class="content">
          <div v-html="detail.content"></div>
        </div>
        <div class="title">推荐新闻</div>
        <div class="flex news-box" v-if="detail.related && detail.related.length">
          <div @click="toDetail(item)" class="news-item" v-for="(item,index) in detail.related" :key="index">
            <div>
              <img v-if="item.cover && item.cover.length" class="news-item-pic textOne" :src="item.cover[0]"/>
              <img v-else class="news-item-pic textOne" src="../../assets/images/news/icon_02.png"/>
              <div class="news-item-title">{{item.title || ''}}</div>
              <div class="news-item-content textTwo">{{item.excerpt || ''}}</div>
              <div class="news-item-time">{{item.created_at.substr(0,10) || ''}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="switch-box" style="z-index: 999999 !important;">
      <img @click="scrollTop" class="switch-box-item" src="../../assets/images/news/icon_03.png"/>
      <img @click="scrollNext" style="margin-top: 25px" class="switch-box-item" src="../../assets/images/news/icon_04.png"/>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import CallMe from '@/components/callme/index'
export default {
  name:'News',
  components: {
    PCNavbar,
    CallMe,
  },
  data() {
    return {
      activeIndex: 0,
      tabList:[],
      detail:{},
      list:[],
      totalList:[],
      play:{},
    };
  },
  created() {

  },
  watch:{
    $route:{
      handler(value){
        if(value.path === '/news/detail'){
          if(value.query.id && value.query.type){
            this.getType(value.query.type).then(res=>{
              this.tabList = res.data;
              this.getDetail(value.query.id);
            })
          }
        }
      },
      deep:true,
      immediate:true
    },
  },
  methods: {
    // 切换
    tabSwitch(item) {
      console.log(item)
      this.$router.push({
        path:item.href,
      })
    },
    scrollTop(){
      window.scrollBy({
        top: -500,
        behavior: 'smooth'  // 平滑滚动
      });
    },
    scrollNext(){
      window.scrollBy({
        top: 500,
        behavior: 'smooth'  // 平滑滚动
      });
    },
    swiperPrev(){
      this.$refs.swiper.prev()
    },
    swiperNext(){
      this.$refs.swiper.next()
    },
    // 获取新闻详情
    getDetail(id){
      this.$request({
        url: `detail/${id}`,
        method: 'get',
      }).then(res=>{
        this.detail = res.data;
        this.swiper();
        for(let i=0;i<this.tabList.length;i++){
          if(this.detail.category.slug == this.tabList[i].slug){
            this.activeIndex = i;
            break
          }
        }
      })
    },
    // 处理轮播
    swiper(){
      let list = [];
      if(this.detail.video_url){
        list.push({
          url:this.detail.video_url,
          type:'video'
        })
      }
      if(this.detail.thumb && this.detail.thumb.length){
        for(let i=0;i<this.detail.thumb.length;i++){
          list.push({
            url:this.detail.thumb[i],
            type:'image'
          })
        }
      };
      this.totalList = list;
      this.list = this.splitArray(list,6);
      if(this.list.length){
        this.play = this.list[0][0];
      }
      this.$forceUpdate();
    },
    // 数组分割
    splitArray(arr, groupSize) {
      const result = [];
      for (let i = 0; i < arr.length; i += groupSize) {
        result.push(arr.slice(i, i + groupSize)); // 每次切割6个元素
      }
      return result;
    },
    // 获取新闻分类
    getType(type){
      return this.$request({
        url: `submenu/${type}`,
        method: 'get',
      })
    },
    // 跳转详情
    toDetail(item){
      this.$router.push({
        path:'/news/detail',
        query:{
          id:item.id,
          type:item.category.slug
        },
      })
    },
    //选中播放
    select(item){
      this.play = item;
      this.$forceUpdate();
      console.log(item,'item')
    },
  }
}
</script>

<style scoped lang="scss">
.container{
  width: 100%;
  .tab{
    width: 100%;
    padding: 0 30vw;
    height: 70px;
    display: flex;
    font-size: 16px;
    color: #333333;
    justify-content: space-between;
    margin-top: -10px;
    background: #f5f5f5;
    .tab-item{
      height: 70px;
      line-height: 70px;
      cursor: pointer;
    }
    .tab-item-select{
      border-bottom: solid 2px #2A59AB;
    }
  }
  .detail{
    padding: 92px 0;
    .detail-top{
      padding-bottom: 51px;
      border-bottom: solid 2px #BFBFBF;
      .detail-title{
        font-size: 36px;
        color: #333333;
        text-align: center;
      }
      .detail-tips{
        margin-top: 26px;
        justify-content: center;
        font-size: 16px;
        color: #333333;
      }
    }
    .swiper-top-box{
      margin-top: 55px;
      .swiper-top-item-pic{
        margin-left: 20px;
        width: 100%;
        height: 550px;
        min-width: 1336px;
        object-fit: cover;
        display: block;
        clear: both;
      }
    }
    .swiper-box{
      width: 1336px;
      justify-content: space-between;
      margin: 20px auto auto;
      .swiper-switch{
        width: 21.89px;
        height: 56.93px;
        cursor: pointer;
      }
      .swiper{
        width: 1250px;
        height: 121.92px;
        overflow: hidden;
        .swiper-item{
          width: 1250px;
          .swiper-pic-box{
            flex: 0 0 16.66%;
            justify-content: center;
            //padding: 0 4px;
            box-sizing: border-box;
            height: 121.92px;

            .swiper-pic-select{
              border: solid 3px #3966b0;
              box-sizing: border-box;
            }
            .swiper-pic{
              width: 192.07px;
              height: 121.92px;
              background-size: cover;
              color: #ffffff;
              flex-direction: column;
              justify-content: end;
              align-items: flex-end;
              font-size: 20px;
              box-sizing: border-box;
              cursor: pointer;
            }
          }
        }
      }
    }
    .content{
      margin-top: 53px;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      line-height: 34px;
    }
    .title{
      margin-top: 106px;
      font-weight: bold;
      font-size: 30px;
      color: #333333;
    }
    .news-box{
      margin-top: 46px;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;
      .news-item{
        cursor: pointer;
        box-sizing: border-box;
        flex: 0 0 33%;
        justify-content: center;
        .news-item-pic{
          width: 445px;
          height: 275px;
          object-fit: cover;
        }
        .news-item-title{
          margin-top: 5px;
          font-weight: 600;
          font-size: 16px;
          color: #282828;
          padding: 0 17px;
        }
        .news-item-content{
          margin-top: 10px;
          padding: 0 17px;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          line-height: 20px;
          -webkit-line-clamp: 3 !important;
        }
        .news-item-time{
          margin-top: 10px;
          padding: 0 17px;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          line-height: 20px;
        }
      }
    }
  }
}
.switch-box{
  position: fixed;
  top:45vh;
  right: 0.5vw;
  background: #ffffff;
  padding: 15px 8px;
  border-radius: 40px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  .switch-box-item{
    display: block;
    width: 70px;
    height: 70px;
    cursor: pointer;
  }
}
</style>
